import { gql, useQuery } from "@apollo/client";
import Loader from "../../../genericComponents/Loader";
import LineChartCard from "./LineChartCard";
import { forwardRef, useEffect, useImperativeHandle, useState } from "react";

const WeekdayChart = ({ id, level, meterType, height, start, end, setDownloadContent, width }) => {

    // Generate all 96 time slots (00:00 to 23:45 in 15-minute intervals)
    const generateTimeSlots = () => {
        const slots = [];
        for (let hour = 0; hour < 24; hour++) {
            for (let minute = 0; minute < 60; minute += 15) {
                const timeString = `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`;
                slots.push(timeString);
            }
        }
        return slots; // Returns 96 time slots
    };

    // Fill missing time slots with y=0
    const normalizeChartData = (data) => {
        const timeSlots = generateTimeSlots();
        const dataMap = new Map(data.map(point => [point.x, point.y]));
        
        return timeSlots.map((timeSlot, index) => ({
            x: timeSlot,
            y: dataMap.has(timeSlot) ? dataMap.get(timeSlot) : 0,
            id: index
        }));
    };

    const GET_WEEKDAYCHART = `query getLineChartByWeekday($id:UUID!,$level:Level!,$meterType:MeterType!,$start:DateTime!,$end:DateTime!){
        lineChartByWeekday(chartInput:{id: $id,level: $level,meterType:$meterType,start: $start,end:$end}){
            name
            points
            {
                x
                y
            }
        }
    }`

    const { data, loading } = useQuery(gql(GET_WEEKDAYCHART),
        { variables: { id: id, level: level, meterType: meterType, start: start, end: end } }
    )

    if (loading || !data) {
        return <Loader height={height} text={"Loading data..."} />
    }

    // Filter out invalid data points and normalize to 96 entries
    const charts = data.lineChartByWeekday.map(x => {
        const filteredData = x.points
            .filter(y => y && y.x !== null && y.x !== undefined && y.y !== null && y.y !== undefined)
            .map(y => ({ x: y.x, y: y.y }));
        
        return {
            label: x.name,
            data: normalizeChartData(filteredData) // Always returns 96 entries
        };
    });
    console.log({ charts });

    // Filter out charts that have no valid data at all (all zeros)
    const validCharts = charts.filter(c => c.data.some(point => point.y !== 0));
    console.log({ validCharts });

    if (validCharts.length === 0) {
        return <Loader height={height} text={"No data available"} />
    }

    // Verify all charts have exactly 96 entries
    validCharts.forEach(chart => {
        if (chart.data.length !== 96) {
            console.error(`Chart "${chart.label}" has ${chart.data.length} entries instead of 96`);
        }
    });

    return <LineChartCard type="Weekdays" meterType={meterType} width={width} height={height} charts={validCharts} />
};

export default WeekdayChart;